module.exports = __webpack_public_path__ + "img/pintrest-icon.993bca21.svg";